import { render } from "./AllChains.vue?vue&type=template&id=af0bde80"
import script from "./AllChains.vue?vue&type=script&lang=js"
export * from "./AllChains.vue?vue&type=script&lang=js"

import "./AllChains.vue?vue&type=style&index=0&id=af0bde80&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__